import { matchPhone } from '@/utils/tools'

const { isIOS, isAndroid } = matchPhone()

const handleNoNative = (method: string, callBack?: () => void) => {
    console.warn('未找到原生方法' + method)
    callBack?.()
}

//全屏
export const fullScreen = function (): void {
    console.info('isIOS', isIOS, 'isAndroid', isAndroid, '原生方法 全屏')
    if (isIOS) {
        window.setupWebViewJavascriptBridge(
            (bridge: { callHandler: (arg0: any, arg1: any, arg2: (result: any) => void) => void }) => {
                bridge.callHandler('fullScreen', '', () => {
                    console.log('调用ios 原生方法 全屏 fullScreen')
                })
            },
        )
    } else if (isAndroid) {
        window?.android?.invokingMethods('fullScreen', '') ?? handleNoNative('fullScreen')
    }
}

// 退出全屏
export const showTop = function (): void {
    console.info('isIOS', isIOS, 'isAndroid', isAndroid, '原生方法 退出全屏')
    if (isIOS) {
        window.setupWebViewJavascriptBridge(
            (bridge: { callHandler: (arg0: any, arg1: any, arg2: (result: any) => void) => void }) => {
                bridge.callHandler('showTop', '', () => {
                    console.log('调用ios 原生方法 退出全屏 showTop')
                })
            },
        )
    } else if (isAndroid) {
        window?.android.invokingMethods('showTop', '') ?? handleNoNative('showTop')
    }
}

//关闭webview
export const closeWebview = function (): void {
    console.info('isIOS', isIOS, 'isAndroid', isAndroid, '原生方法 关闭webview')
    if (isIOS) {
        window.setupWebViewJavascriptBridge(
            (bridge: { callHandler: (arg0: any, arg1: any, arg2: (result: any) => void) => void }) => {
                bridge.callHandler('back', '', () => {
                    console.log('调用ios 原生方法 关闭webview back')
                })
            },
        )
    } else if (isAndroid) {
        window?.android?.invokingMethods('back', '') ?? handleNoNative('back')
    }
}

// 获取token
export const getToken = async function () {
    console.info('isIOS', isIOS, 'isAndroid', isAndroid, '原生方法getToken')
    if (isIOS) {
        return new Promise((resolve, reject) => {
            window.setupWebViewJavascriptBridge((bridge: { callHandler: (arg0: string, arg1: string, arg2: (result: string) => void) => void }) => {
                console.info('bridge', bridge);
                if (!bridge) return resolve('')
                bridge && bridge.callHandler('token', '', (result: string) => {
                    // console.info('调用ios方法, ', '返回值', result)
                    resolve(result)
                })
            },
            )
        })
    } else if (isAndroid) {
        // console.info('原生方法获取Token', window?.android.getInvokeData('token'))
        return new Promise(resolve => {
            const androidToken = window?.android.getInvokeData('token') || ''
            resolve(androidToken)
        })
    } else {
        return Promise.resolve('')
    }
}

//点击跳转到app产品列表
export const toProduct = function () {
    console.info('isIOS', isIOS, 'isAndroid', isAndroid, '原生方法toProduct')
    if (isIOS) {
        window.setupWebViewJavascriptBridge(
            (bridge: { callHandler: (arg0: any, arg1: any, arg2: (result: any) => void) => void }) => {
                bridge.callHandler('toProduct', '', () => {
                    console.log('调用ios 原生方法 跳转到app产品列表 toProduct')
                })
            },
        )
    } else if (isAndroid) {
        console.log('原生方法获取Product', window?.android.invokingMethods('toProduct', ''))
        window?.android.invokingMethods('toProduct', '') ?? handleNoNative('toProduct')
    }
}

//修改手机号或密码退出登录
export const loginOut = function () {
    console.info('isIOS', isIOS, 'isAndroid', isAndroid, '原生方法 退出登录')
    if (isIOS) {
        window.setupWebViewJavascriptBridge(
            (bridge: { callHandler: (arg0: any, arg1: any, arg2: (result: any) => void) => void }) => {
                bridge.callHandler('logOut', '', () => {
                    console.log('调用ios 原生方法 退出登录 logOut')
                })
            },
        )
    } else if (isAndroid) {
        window?.android.invokingMethods('logOut', '') ?? handleNoNative('logOut')
    }
}

// 获取顶部、底部距离     tatusBarHeight 顶部状态栏高度 navigationBarHeight 导航栏高度 tabBarFullHeight 底部安全区域
export const sysDeviceDimension = function () {
    console.info('isIOS', isIOS, 'isAndroid', isAndroid, '原生方法 获取顶部、底部距离')
    if (isIOS) {
        return new Promise(resolve => {
            window.setupWebViewJavascriptBridge(
                (bridge: { callHandler: (arg0: string, arg1: string, arg2: (result: string) => void) => string }) => {
                    bridge.callHandler('sysDeviceDimension', '', (result: string) => {
                        // console.info('调用ios方法 原生方法 获取顶部、底部距离, ', '返回值', result)
                        resolve(result)
                    })
                },
            )
        })
    } else {
        return Promise.resolve('{}')
    }
}

// 唤起登录
export const openLoginPage = function () {
    console.info('isIOS', isIOS, 'isAndroid', isAndroid, '原生方法 唤起登录')
    if (isIOS) {
        window.setupWebViewJavascriptBridge(
            (bridge: { callHandler: (arg0: string, arg1: string, arg2: (result: string) => void) => string }) => {
                bridge.callHandler('login', '', (result: string) => {
                    // console.info('调用ios方法 原生方法 唤起登录, ', '返回值', result)
                })
            },
        )
    } else {
        window?.android.invokingMethods('login', '') ?? handleNoNative('login')
    }
}

// 刷新原生个人信息
export const refreshPersonalInformation = function () {
    console.info('isIOS', isIOS, 'isAndroid', isAndroid, '原生方法 刷新个人信息')
    if (isIOS) {
        window.setupWebViewJavascriptBridge(
            (bridge: { callHandler: (arg0: string, arg1: string, arg2: (result: string) => void) => string }) => {
                bridge.callHandler('refreshPersonalInformation', '', (result: string) => {
                    // console.info('调用ios方法 原生方法 刷新个人信息, ', '返回值', result)
                })
            },
        )
    } else {
        window?.android.invokingMethods('refreshPersonalInformation', '') ??
            handleNoNative('refreshPersonalInformation')
    }
}

/**
 * 加密 param： h5要加密的json字符串
 * 返回值： 
 * {
 *  "encryptedString":"加密过的字符串，H5 放在请求体中，请求头插入键值对content-type:application/json",
    "encryptenKey":"用SM2加密过的SM4秘钥，H5放在请求头中，请求头插入一个键值对  key:本字符串"，
    "xkey":"H5置于内存中，解密时传给原生即可,无需传给后端"
   }
*/
export const doNativeEncrypt = function (json = '') {
    console.info('isIOS', isIOS, 'isAndroid', isAndroid, '原生方法 加密', '参数', json)
    if (isIOS) {
        return new Promise(resolve => {
            window.setupWebViewJavascriptBridge(
                (bridge: { callHandler: (arg0: string, arg1: string, arg2: (result: string) => void) => string }) => {
                    bridge.callHandler('doNativeEncrypt', json, (result: string) => {
                        // console.info('调用ios方法 原生方法 加密, ', '返回值：', result)
                        resolve(result)
                    })
                },
            )
        })
    } else if (isAndroid) {
        return new Promise(resolve => {
            const result = window?.android.invokingMethods('doNativeEncrypt', json) || {}
            // console.info('调用android方法 原声方法 加密, 参数', json, '返回值', result)
            resolve(result)
        })
    }
}

/**
 * 解密
 * 参数 param: '{ content: '服务端返回的密文', xkey: '上一步骤中原生端提供给H5的值'}'
 * 返回解密后的字符串
 */
export const doNativeDecrypt = function (param: string) {
    // console.info('isIOS', isIOS, 'isAndroid', isAndroid, '原生方法 加密 参数', param)
    if (isIOS) {
        return new Promise(resolve => {
            window.setupWebViewJavascriptBridge(
                (bridge: { callHandler: (arg0: string, arg1: string, arg2: (result: string) => void) => string }) => {
                    bridge.callHandler('doNativeDecrypt', param, (result: string) => {
                        console.info('调用ios方法 原生方法 加密, ', '返回值：')
                        resolve(result)
                    })
                },
            )
        })
    } else if (isAndroid) {
        return new Promise(resolve => {
            const result = window?.android.invokingMethods('doNativeDecrypt', param) || {}
            // console.info('调用android方法 原声方法 加密 参数', param, 'result')
            resolve(result)
        })
    }
}

// 刷新公钥 服务端返回9011时使用，调用此方法后继续重复加密操作
export const refreshPubKey = function () {
    console.info('isIOS', isIOS, 'isAndroid', isAndroid, '原生方法 刷新公钥')
    if (isIOS) {
        return new Promise(resolve => {
            window.setupWebViewJavascriptBridge(
                (bridge: { callHandler: (arg0: string, arg1: string, arg2: (result: string) => void) => string }) => {
                    bridge.callHandler('refreshPubKey', '', (result: string) => {
                        // console.info('调用ios方法 原生方法 刷新公钥, ', '返回值', result)
                    })
                },
            )
        })
    } else {
        return new Promise(resolve => {
            const result = window?.android.invokingMethods('refreshPubKey', '')
            // console.info('调用android方法 原声方法 刷新公钥 参数 result', result)
            resolve(result)
        })
    }
}

//检测用户是否开启相机
export const checkCamera = function () {
    console.info('isIOS', isIOS, 'isAndroid', isAndroid, '原生方法 检测相机是否开启')
    if (isIOS) {
        return new Promise(resolve => {
            window.setupWebViewJavascriptBridge(
                (bridge: { callHandler: (arg0: any, arg1: any, arg2: (result: any) => void) => void }) => {
                    bridge.callHandler('monitoringCameraPermission', '', result => {
                        console.log('检查返回相机状态',result,'iosopen',result.iosOpen,'isFirst',result.isFirst)
                        resolve(result.iosOpen)
                    })
                },
            )
        })
    }
}

//跳转到系统设置
export const settingController =function () {
    console.info('isIOS', isIOS, 'isAndroid', isAndroid, '原生方法 跳转到系统设置')
    window.setupWebViewJavascriptBridge(
        (bridge: { callHandler: (arg0: any, arg1: any, arg2: (result: any) => void) => void }) => {
            bridge.callHandler('pushSettingController', '', () => {
                console.log('系统设置')
            })
        },
    )
}

// 传递阿里云滑块成功参数
export const slideSuccess = function (json: any) {
    console.info('isIOS', isIOS, 'isAndroid', isAndroid, '原生方法 阿里云滑块成功参数')
    if (isIOS) {
        window.setupWebViewJavascriptBridge(
            (bridge: { callHandler: (arg0: any, arg1: any, arg2: (result: any) => void) => void }) => {
                bridge.callHandler('slideData', json, () => {
                    // console.log('原生方法 阿里云滑块成功参数')
                })
            },
        )
    } else {
        window?.android.invokingMethods('slideData', json) || {}
    }
}

// 传递阿里云滑块失败参数
export const slideFaild = function (json: any) {
    console.info('isIOS', isIOS, 'isAndroid', isAndroid, '原生方法 阿里云滑块失败参数')
    if (isIOS) {
        window.setupWebViewJavascriptBridge(
            (bridge: { callHandler: (arg0: any, arg1: any, arg2: (result: any) => void) => void }) => {
                bridge.callHandler('slideFailed', json, () => {
                    // console.log('原生方法 阿里云滑块失败参数')
                })
            },
        )
    } else {
        window?.android.invokingMethods('slideFailed', json) || {}
    }
}

// 消息中心查看详情与原生交互
export const toServerRouting = function (json = '') {
    if (isIOS) {
        window.setupWebViewJavascriptBridge(
            (bridge: { callHandler: (arg0: any, arg1: any, arg2: (result: any) => void) => void }) => {
                bridge.callHandler('toServerRouting', json, () => {
                    console.log('消息中心查看详情与原生交互')
                })
            },
        )
    } else {
        window?.android.invokingMethods('toServerRouting', json) || {}
    }
}
